import gql from 'graphql-tag';
import { WalletFragment } from '../fragments/wallet.fragment';

export const WALLET_LIST = gql`
    mutation(
        $userId: String!
    ) {
        walletList (
            userId: $userId
            ) {
            ...WalletInfo
        }
    }
    ${WalletFragment}
`;